// src/components/Sidebar.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  
  const handleLinkClick = () => {
    if (window.innerWidth <= 768 && isOpen) {
      toggleSidebar();
    }
  };

  return (
    <>
      {isOpen && window.innerWidth <= 768 && (
        <div className="sidebar-overlay" onClick={toggleSidebar} />
      )}
      
      <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="logo-container">
            <div className="logo">
              <img 
                src={`${process.env.PUBLIC_URL}/genus_logo.png`} 
                alt="Genus" 
                className="logo-image" 
              />
            </div>
          </div>
        </div>
        
        <nav className="sidebar-nav">
          <Link 
            to="/home" 
            className={`sidebar-link ${location.pathname === '/' || location.pathname === '/home' ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            <span className="sidebar-icon">🏠</span>
            <span className="sidebar-text">Home</span>
          </Link>
          
          <Link 
            to="/summary" 
            className={`sidebar-link ${location.pathname === '/summary' ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            <span className="sidebar-icon">📊</span>
            <span className="sidebar-text">Summary</span>
          </Link>

          <Link 
            to="/settings" 
            className={`sidebar-link ${location.pathname === '/settings' ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            <span className="sidebar-icon">⚙️</span>
            <span className="sidebar-text">Settings</span>
          </Link>
        </nav>
        
        <div className="sidebar-footer">
          <div className="footer-text">GenOps v1.0</div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;